const CART_MODE = 'cart_mode';
const AUTH_MODE = 'auth_mode';
const CONFIRM_SALE_MODE = 'confirm_sale_mode';
const WAITING_CONFIRMATION_MODE = 'waiting_confirmation_mode';
const PAYMENT_MODE = 'payment_mode';
const BUYER_INFO_EXTRATION_MODE = 'buyer_info_extration_mode';
const SUCCESSFUL_PAYMENT = 'successful_payment';
const SALE_MODE = 'sale_mode';

/** Every mode the legacy checkout can be in. The new checkout no longer reaches SALE_MODE. */
export type LegacyCheckoutMode =
  | typeof CART_MODE
  | typeof AUTH_MODE
  | typeof CONFIRM_SALE_MODE
  | typeof WAITING_CONFIRMATION_MODE
  | typeof PAYMENT_MODE
  | typeof BUYER_INFO_EXTRATION_MODE
  | typeof SUCCESSFUL_PAYMENT
  | typeof SALE_MODE;

export {
  CART_MODE,
  AUTH_MODE,
  CONFIRM_SALE_MODE,
  WAITING_CONFIRMATION_MODE,
  PAYMENT_MODE,
  BUYER_INFO_EXTRATION_MODE,
  SUCCESSFUL_PAYMENT,
  SALE_MODE,
};
